import { useEffect, useState } from 'react';

import { Icon, IconButton, Notification, } from 'rsuite';
import { Grid, Container, } from '@material-ui/core';

import {
  listMonitoring,
  listCompanies,
  listBackupAlerts,
  listTickets,
  sendBackupAlertEmailReport,
} from '../../services/api';
import { asList, } from '../../services/list';

import NavBar from '../../components/NavBar/NavBar';
import BackupAlerts from './BackupAlerts';
import ServerMonitoringTable from './ServerMonitoringTable';
import OverviewPanel from '../../components/OverviewPanel/index';
import NewTicketFAB from '../../components/NewTicketFAB/index.jsx';

import '../Main/Main.css';

import { isServerAlertActive, } from '../../entities/server';
import { hasExpiringHours, } from '../../entities/company';
import { TicketStatus, } from '../../entities/ticket';


function MainDashboard() {
  const user = localStorage.getItem('name');
  const [loading, seLoading] = useState(true);
  const [body, setBody] = useState([]);
  const [bodyEmp, setBodyEmp] = useState([]);
  const [mon, setMon] = useState([]);
  const [chamados, setChamados] = useState([]);

  const openTickets = chamados.filter(({ status, }) => TicketStatus.OPEN === status);
  const serversWithError = mon.filter(isServerAlertActive);
  const clientsWithExpiringHours = bodyEmp.filter(hasExpiringHours);


  async function getData() {
    seLoading(true);

    try {
      await Promise.all([
        listCompanies(true).then(({ data }) => {
          setBodyEmp(asList(data))
        }),
        listTickets().then(({ data }) => {
          setChamados(asList(data))
        }),
        listBackupAlerts().then(({ data }) => {
          setBody(asList(data))
        }),
        listMonitoring().then(({ data }) => {
          setMon(asList(data))
        }),
      ]);
    } catch (err) {
      Notification['error']({
        placement: 'bottomEnd',
        title: 'Erro ao carregar o dashboard',
        description: 'Não foi possível carregar todos os dados. Tente atualizar.',
      });
    } finally {
      // sem o finally uma rota fora do ar deixava o dashboard travado no loading
      seLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  function sendEmail() {
    sendBackupAlertEmailReport().then(() => {
      return Notification['success']({
        placement: 'bottomEnd',
        title: 'Email enviado com sucesso',
      })
    })
  }


  return (
    <NavBar>
      <br />

      <Container
        disableGutters
        maxWidth="xl"
      >
        <Grid
          container
          spacing={1}
        >
          <div className="WelcomeUsers">
            Seja bem vindo <span>{user}</span>
          </div>

          <OverviewPanel
            backupAlertsCount={body.length}
            openTicketsCount={openTickets.length}
            clientsWithExpiringHoursCount={clientsWithExpiringHours.length}
            serversWithErrorCount={serversWithError.length}
          />

          <div className="subTitle">
            <div className="titleSection">
              <h5>Monitoramento</h5>
            </div>
            <IconButton
              appearance="ghost"
              onClick={getData}
              icon={<Icon icon="refresh" />}
            >
              Atualizar
            </IconButton>
          </div>

          <ServerMonitoringTable
            loading={loading}
            data={serversWithError}
          />

          <BackupAlerts
            backupAlerts={body}
            loading={loading}
            onSendEmail={sendEmail}
          />
        </Grid>
      </Container>

      <NewTicketFAB />
    </NavBar>
  )
}

export default MainDashboard;
